import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { serialize } from '../../utils/helpers/model.helper';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { LoggerService } from '../shared/services/logger/logger.service';
import { AccountUser } from './account-user.model';
import { map } from 'rxjs/operators';

@Injectable()
export class AccountUserDataService {
  private _accountUserServicesUrl: string = '/as/account/users';

  topLevelKeys = {
    getKey: 'account_users',
    putKey: 'account_user',
  };

  constructor(
    private _loggerService: LoggerService,
    private _authHttpService: AuthHttpService
  ) {}

  getAccountUsers(): Observable<List<AccountUser>> {
    this._loggerService.log('get account users from network');

    return this._authHttpService.get(this._accountUserServicesUrl).pipe(
      map(({ body, ..._ }: IResponseInfo) => {
        return List<AccountUser>(
          (body[this.topLevelKeys.getKey] || []).map(
            (value) => new AccountUser(value)
          )
        );
      })
    );
  }

  addAccountUser(accountUser: AccountUser): Observable<AccountUser> {
    this._loggerService.log('create account user');

    const url = Location.joinWithSlash(this._accountUserServicesUrl, 'add');
    const payload = serialize(accountUser)
      .delete(AccountUser.KEYS.USER_ID)
      .toJS();

    return this._authHttpService
      .put(url, payload)
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new AccountUser(body[this.topLevelKeys.putKey])
        )
      );
  }

  updateAccountUser(accountUser: AccountUser): Observable<AccountUser> {
    this._loggerService.log('update account user');

    const url = Location.joinWithSlash(this._accountUserServicesUrl, 'role');
    const payload = serialize(accountUser)
      .delete(AccountUser.KEYS.EMAIL)
      .toJS();

    return this._authHttpService
      .put(url, payload)
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new AccountUser(body[this.topLevelKeys.putKey])
        )
      );
  }

  deleteAccountUser(userId: string): Observable<IResponseInfo> {
    this._loggerService.log('delete account user', userId);

    const url = Location.joinWithSlash(this._accountUserServicesUrl, userId);

    return this._authHttpService.delete(url);
  }
}
